import { MasterL10nMessages } from '@sm/question-ui/respondent-quiz-results';
import { defineMessages } from '@sm/intl';

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */
export const COPY: MasterL10nMessages = defineMessages({
  SCORE: {
    id: 'QuizResultScore.SCORE',
    defaultMessage: '{score}/{total} {total, plural, one {point} other {points}}',
    description: '[Type: header][Vis: med] - total achieved point(s) of this quiz question',
  },
  SKIPPED: {
    id: 'QuizResultScore.SKIPPED',
    defaultMessage: 'Skipped',
    description: '[Type: header][Vis: med] - user skipped this quiz question',
  },
  CORRECT: {
    id: 'SrText.CORRECT',
    defaultMessage: 'Correct',
    description: '[Type: label][Vis: med] - the answer was correct',
  },
  INCORRECT: {
    id: 'SrText.INCORRECT',
    defaultMessage: 'Incorrect',
    description: '[Type: label][Vis: med] - the answer was incorrect ',
  },
});

export default COPY;
